import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
    addUrlToArray,
    clearAvatarUrl,
    saveAvatarUrl,
    switchIsNecessaryToShowBackButtonOnTrue,
    switchIsNecessaryToShowBackButtonOnFalse,
    switchIsNecessaryToShowAvatarOnTrue,
    switchIsNecessaryToShowAvatarOnFalse,
    initOfSavingPath,
    switchIsNecessaryToDeleteAvatarOnTrue,
    switchIsNecessaryToDeleteAvatarOnFalse,
    switchIsNecessaryToGetAvatarFromContributionOnTrue
} from '../store/common/commonSlice'
import { RootState } from '../store/rootReducer'
import { useEffect } from 'react'
import { BackButtonType } from '../store/common/commonSliceTyping'
import { ProfileState } from '../store/profile/profileTypings'
import { ContributionType } from '../store/contributions/contributionsTypings'

export const useSaveAvatar = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const profile = useSelector<RootState, ProfileState>((state) => state.profile)
    const backButton = useSelector<RootState, BackButtonType>((state) => state.common.backButton)
    useEffect(() => {
        if (backButton.isNecessaryToGetAvatarFromContribution && profile.user) {
            dispatch(saveAvatarUrl(profile.user.avatar_url))
        }
        return () => {
            dispatch(switchIsNecessaryToGetAvatarFromContributionOnTrue())
        }
    }, [location])
}

export const useSaveUrl = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    useEffect(() => {
        dispatch(addUrlToArray(location.pathname))
    }, [])
}

export const useShowBackButton = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const backButton = useSelector<RootState, BackButtonType>((state) => state.common.backButton)
    const contribution = useSelector<RootState, ContributionType>((state) => state.contributions.contribution)
    useEffect(() => {
        dispatch(switchIsNecessaryToShowBackButtonOnTrue())
        if (
            (location.pathname.includes('photo') || location.pathname.includes('video')) &&
            !backButton.urlList.length
        ) {
            dispatch(addUrlToArray(contribution.url))
        }
        return () => {
            dispatch(switchIsNecessaryToShowBackButtonOnFalse())
        }
    }, [])
}

export const useShowAvatarOnBackButton = () => {
    const contribution = useSelector<RootState, ContributionType>((state) => state.contributions.contribution)
    const backButton = useSelector<RootState, BackButtonType>((state) => state.common.backButton)
    const dispatch = useDispatch()
    const location = useLocation()
    useEffect(() => {
        dispatch(switchIsNecessaryToShowAvatarOnTrue())
        //
        // this block is needed to get an avatar if the user did not go from the profile page
        if (
            (location.pathname.includes('photo') || location.pathname.includes('video')) &&
            !backButton.avatarUrl &&
            backButton.isNecessaryToGetAvatarFromContribution
        ) {
            dispatch(switchIsNecessaryToDeleteAvatarOnTrue())
            dispatch(saveAvatarUrl(contribution.user.avatar_url))
        }
        if (backButton.isNecessaryToDeleteAvatar) {
            dispatch(switchIsNecessaryToDeleteAvatarOnFalse())
            dispatch(clearAvatarUrl())
        }
        //
        //
        return () => {
            dispatch(switchIsNecessaryToShowAvatarOnFalse())
            dispatch(switchIsNecessaryToGetAvatarFromContributionOnTrue())
        }
    }, [location])
}

export const useInitOfSavingPath = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const backButton = useSelector<RootState, BackButtonType>((state) => state.common.backButton)

    useEffect(() => {
        if (!backButton.urlList.includes(location.pathname)) dispatch(initOfSavingPath(location.pathname))
    }, [])
}

export const useInitOfSavingClearPath = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    useEffect(() => {
        dispatch(clearAvatarUrl())
        dispatch(initOfSavingPath(location.pathname))
    }, [])
}

export const useInitOfSavingSearchPath = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    useEffect(() => {
        dispatch(clearAvatarUrl())
        dispatch(initOfSavingPath(location.pathname))
    }, [location.pathname, location.search])
}
